export function formatPossession(noun: string) {
  return noun[noun.length - 1] === 's' ? noun + "'" : noun + "'s";
}
